import $ from 'jquery';

import lightGallery from 'lightgallery';
import 'lightgallery/css/lightgallery-bundle.min.css';

const themeObject = ajaxObjectSarro;

const gallery = lightGallery($('.program-gallery')[0], {
    speed: 500,
    selector: '.gallery-item',
    download: false,
    counter: false,
});

$('.gs-load-more-photos').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const button = $(this);
    const wrapper = $('.gallery-slider');
    const ids = button.parent().data('ids');
    const data = {
        action: 'mof_more_photos',
        nonce: themeObject.nonce,
        ids,
    };

    $.ajax({
        url: themeObject.ajaxUrl,
        method: 'POST',
        dataType: 'JSON',
        data,
        success: function (response) {
            if (response.success) {
                wrapper.append(response.data.res);
                wrapper.find('.loaded').addClass('slide-in-bottom');
                gallery.refresh();
                button.remove();
            }
        },
    });
});
